import { render } from "./valueProposition.vue?vue&type=template&id=2611acd6"
import script from "./valueProposition.vue?vue&type=script&lang=js"
export * from "./valueProposition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__